import * as React from "react";
import { forwardRef } from "react";
const SvgDefault = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 20 20", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M13.695 10 6.28 2.622a.947.947 0 0 1 0-1.344.958.958 0 0 1 1.35 0l8.09 8.05a.947.947 0 0 1 0 1.344l-8.09 8.05a.958.958 0 0 1-1.35 0 .947.947 0 0 1 0-1.344L13.695 10z" }));
const ForwardRef = forwardRef(SvgDefault);
export { ForwardRef as ReactComponent };
